import React from 'react';
import { IContentContainer } from './interfaces';
import { Box } from '@mui/material';

export const ContentContainer: React.FC<IContentContainer> = ({
  children,
  sidebarMenuOffset = '0px',
}): JSX.Element => {
  return (
    <Box
      component="main"
      sx={{
        // flexGrow: 1,
        ml: `calc(${sidebarMenuOffset} + 15px)`,
        mt: '15px',
        mr: '15px',
        mb: '15px',
      }}
    >
      {children}
    </Box>
  );
};
